import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stationIconCard' })
export class StationIconCardPipe implements PipeTransform {
  transform(station): any {
    const stationType = station['stationType'];
    return stationType === 'gma' || stationType === '3'
      ? ['far', 'road']
      : ['far', 'house-day'];
  }
}
